import { EventBus } from '../../../../core/shared/helpers/EventHelper';
import ItemComponent from '../../../../core/infraestructure/ItemComponent';
import CareerViewModel from '../../../../core/features/setting/viewmodels/CareerViewModel';

export default {
    extends: ItemComponent,
    data() {
        return {
            modulePermissions: 'Settings-Careers',
            isUniversity: true,
            universities: [],
            knowledgeAreas: [],
            viewModel: null,
            permissions: null,
            modules: [],
            rules: {
                code: [
                    { required: true, message: 'Código requerido.', trigger: 'blur' }
                ],
                name: [
                    { required: true, message: 'Nombre requerido.', trigger: 'blur' }
                ],
                university: [
                    { required: true, message: 'Universidad requerida.', trigger: 'change' }
                ],
                knowledgeArea: [
                    { required: true, message: 'Área de Conocimiento requerida.', trigger: 'change' }
                ],
            }
        }
    },
    props: {
        conf: {
            type: Object,
            required: true
        },
        formData: {
            type: Object,
            required: true
        }
    },
    created() {
        this.viewModel = new CareerViewModel(this)
        this.onActive()
    },
    mounted() { },
    methods: {
        onActive() {
            this.viewModel.bindFormView();
        },
        onFindUniversity(data) {
            if (data) {
                this.viewModel.findUniversities(`Name=${data}`)
            } else {
                this.universities = []
            }
        },
        onFindUniversitiesResponse(response) {
            this.universities = response;
        },
        onSelectUniversity(data) {
            if (data) {
                this.viewModel.findKnowledgeAreas(`UniversityId=${data.id}`)
            } else {
                this.knowledgeAreas = []
                this.isUniversity = true;
            }
        },
        onFindKnowledgeAreasResponse(response) {
            this.knowledgeAreas = response.data;
            this.isUniversity = false;
        },
        onFocus() {
            this.$forceUpdate()
        },
        onSubmitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.onSave(this.formData)
                }
            });
        },
        onCanSaveOrUpdate() {
            return this.canCreate(this.modulePermissions) || this.canUpdate(this.modulePermissions)
        },
        onSaveResponse(response) {
            this.showLoading(false, '');
            this.onShowSuccess(response.message);
            this.showComponent(false);
            EventBus.$emit('onSubmitedCareer', null);
        }
    }
}